import React, { useState } from 'react';
import api from '../../api/api';

export default function ClientManagement({ clients, onRefresh }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [isAdding, setIsAdding] = useState(false);
  const [newForm, setNewForm] = useState({
    name: '',
    is_active: true
  });

  const filteredClients = clients.filter(client => 
    client.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredClients.length / itemsPerPage);
  const currentItems = filteredClients.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handleEdit = (client) => {
    setEditingId(client.id);
    setEditForm({ ...client });
  };

  const handleSave = async () => {
    try {
      await api.put(`/master/clients/${editingId}`, {
        name: editForm.name,
        is_active: editForm.is_active
      });
      setEditingId(null);
      onRefresh();
    } catch (error) {
      alert('Failed to update client');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this client?')) return;
    try {
      await api.delete(`/master/clients/${id}`);
      onRefresh();
    } catch (error) {
      alert('Failed to delete client');
    }
  };

  const handleAdd = async () => {
    if (!newForm.name.trim()) {
      alert('Please enter a client name');
      return;
    }
    try {
      await api.post('/master/clients', {
        name: newForm.name
      });
      setIsAdding(false);
      setNewForm({ name: '', is_active: true });
      onRefresh();
    } catch (error) {
      alert('Failed to add client');
    }
  };

  return (
    <>
      <div className="admin-card-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          <h3>Clients</h3>
          <div className="search-box" style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>🔍</span>
            <input 
              type="text" 
              placeholder="Search clients..." 
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              style={{ 
                width: '100%', 
                padding: '0.6rem 1rem 0.6rem 2.5rem', 
                borderRadius: '0.5rem', 
                border: '1px solid #e2e8f0',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        <button className="btn-primary small-btn" onClick={() => setIsAdding(true)}>+ Add Client</button>
      </div>

      {isAdding && (
        <div style={{ padding: '1.5rem', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
          <h4>Add New Client</h4>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
            <input 
              type="text" 
              placeholder="Client Name" 
              value={newForm.name} 
              onChange={e => setNewForm({...newForm, name: e.target.value})}
              style={{ padding: '0.5rem', borderRadius: '0.4rem', border: '1px solid #cbd5e1', minWidth: '250px' }}
            />
            <button className="btn-primary small-btn" onClick={handleAdd}>Save</button>
            <button className="btn-secondary small-btn" onClick={() => setIsAdding(false)}>Cancel</button>
          </div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((client) => (
              <tr key={client.id}>
                <td>
                  {editingId === client.id ? (
                    <input 
                      type="text" 
                      value={editForm.name} 
                      onChange={e => setEditForm({...editForm, name: e.target.value})} 
                      style={{ padding: '0.3rem', borderRadius: '0.3rem', border: '1px solid #cbd5e1', width: '100%' }}
                    />
                  ) : (
                    <strong>{client.name}</strong>
                  )}
                </td>
                <td>
                  {editingId === client.id ? (
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                      <input 
                        type="checkbox" 
                        checked={editForm.is_active} 
                        onChange={e => setEditForm({...editForm, is_active: e.target.checked})} 
                      />
                      {editForm.is_active ? 'Active' : 'Inactive'}
                    </label>
                  ) : (
                    <span className={`status-badge ${client.is_active ? 'active' : 'inactive'}`}>
                      {client.is_active ? 'Active' : 'Inactive'}
                    </span>
                  )}
                </td>
                <td>
                  <div className="actions-cell">
                    {editingId === client.id ? (
                      <button className="action-btn" onClick={handleSave} title="Save">💾</button>
                    ) : (
                      <button className="action-btn" onClick={() => handleEdit(client)} title="Edit">✏️</button>
                    )}
                    <button className="action-btn" onClick={() => handleDelete(client.id)} title="Delete">🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
            {currentItems.length === 0 && (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                  No clients found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container" style={{ padding: '1rem' }}>
          <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button className="pagination-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
